import { config } from "config";
import { options } from "utils";

const filialesEditarApi = {
  getFilialPersonal: async (filialID, query = "") => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/personaldestacado`, options("GET"))
    const data = await resp.json()
    return data
  },
  getVehiculos: async (filialID, query = "") => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/vehiculos?${query}`, options("GET"))
    const data = await resp.json()
    return data
  },
  createVehiculo: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/vehiculos`, options("POST", body))
    const data = await resp.json()
    return data
  },
  updateVehiculo: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/vehiculos`, options("PUT", body))
    const data = await resp.json()
    return data
  },
  getVehiculoSeguros: async (vehiculoID) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/vehiculos/${vehiculoID}/seguros`, options("GET"))
    const data = await resp.json()
    return data
  },
  crearVehiculoSeguro: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/vehiculosseguros`, options("POST", body))
    const data = await resp.json()
    return data
  },
  updateVehiculoSeguro: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/vehiculosseguros`, options("PUT", body))
    const data = await resp.json()
    return data
  },
  getContratistas: async (filialID, query = "") => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/contratistas?${query}`, options("GET"))
    const data = await resp.json()
    return data
  },
  createContratista: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/contratistas`, options("POST", body))
    const data = await resp.json()
    return data
  },
  updateContratista: async (body) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/contratistas`, options("PUT", body))
    const data = await resp.json()
    return data
  },
  guardarDatos: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  getLastDomicilio: async filialID => {
    const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/lastdomicilio`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  createCobertura: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/cobertura`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  borrarCobertura: async coberturaID => {
    const url = `${config.URL_API_PRIVATE}/filiales/cobertura/${coberturaID}`
    const response = await fetch(url, options("DELETE"));
    const data = await response.json();
    return data;
  },
  updateCobertura: async (coberturaID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/cobertura/${coberturaID}`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  updateCoberturaGeotxt: async (coberturaID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/cobertura/${coberturaID}/geotxt`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  getAllLocalidades: async (q = "") => {
    const url = `${config.URL_API_PRIVATE}/localidades?q=${q}`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  borrarLocalidad: async localidadID => {
    const url = `${config.URL_API_PRIVATE}/filiales/localidades/${localidadID}/borrar`
    const response = await fetch(url, options("PUT"));
    const data = await response.json();
    return data;
  },
  getHorario: async filialID => {
    const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/horario`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  guardarHorario: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/horario`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  getZonas: async (filialID) => {
    const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/zonas`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  createZona: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/zonas`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  borrarZona: async zonaID => {
    const url = `${config.URL_API_PRIVATE}/filiales/zonas/${zonaID}`
    const response = await fetch(url, options("DELETE"));
    const data = await response.json();
    return data;
  },
  updateZona: async (zonaID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/zonas/${zonaID}`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  updateZonaGeotxt: async (coberturaID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/zonas/${coberturaID}/geotxt`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  getTiposContactos: async () => {
    const url = `${config.URL_API_PRIVATE}/agendas/tiposcontactos`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  getRoles: async () => {
    const url = `${config.URL_API_PRIVATE}/agendas/roles`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  crearContacto: async (filialID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/contactos`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  getContactos: async (filialID) => {
    const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/contactos`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  getContacto: async contactoID => {
    const url = `${config.URL_API_PRIVATE}/filiales/contactos/${contactoID}`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  editarContacto: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/contactos`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  editarContactoProp: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/contactosprops`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data
  },
  crearContactoProp: async body => {
    const url = `${config.URL_API_PRIVATE}/filiales/contactosprops`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  getFilialesTipos: async () => {
    const url = `${config.URL_API_PRIVATE}/filiales/tipos`
    const response = await fetch(url, options("GET"));
    const data = await response.json();
    return data;
  },
  crearComision: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/comisiones`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },

  getComisiones: async (filialID, query = '') => {
    const response = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/comisiones?${query}`, options("GET"));
    const data = await response.json();
    return data;
  },

  crearSeguro: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/seguros`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  getSeguros: async (filialID, q = '') => {
    const response = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/seguros?${q}`, options("GET"));
    const data = await response.json();
    return data;
  },
  editarSeguro: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/seguros`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  bajaSeguro: async (seguroID) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/seguros/${seguroID}/baja`, options("DELETE",))
    const data = await resp.json()
    return data
  },
  altaSeguro: async (seguroID) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/seguros/${seguroID}/alta`, options("PUT",))
    const data = await resp.json()
    return data
  },

  crearDistancia: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/distancias`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  editarDistancia: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/distancias`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  bajaDistancia: async (distanciaID) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/distancias/${distanciaID}/baja`, options("DELETE"))
    const data = await resp.json()
    return data
  },
  altaDistancia: async (distanciaID) => {
    const resp = await fetch(`${config.URL_API_PRIVATE}/filiales/distancias/${distanciaID}/alta`, options("PUT"))
    const data = await resp.json()
    return data
  },

  editarComision: async (comision, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/comisiones/${comision}`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },

  getExclusiones: async (filialID, q = '') => {
    const response = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/exclusiones?${q}`, options("GET"));
    const data = await response.json();
    return data;
  },
  crearExclusion: async (body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/exclusiones`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
  },
  updateExclusion: async (exclusionID, body) => {
    const url = `${config.URL_API_PRIVATE}/filiales/exclusiones/${exclusionID}`
    const response = await fetch(url, options("PUT", body));
    const data = await response.json();
    return data;
  },
  desactivarExclusion: async (exclusionID) => {
    const url = `${config.URL_API_PRIVATE}/filiales/exclusiones/${exclusionID}/baja`
    const response = await fetch(url, options("PUT"));
    const data = await response.json();
    return data;
  },
  filiales: {
    getCobertura: async (filialID) => {
      const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/cobertura`
      const response = await fetch(url, options("GET"));
      const data = await response.json();
      return data;
    },
    getZonas: async (filialID) => {
      const url = `http://192.168.88.12:5600/api/franquicias/${filialID}/zonas`
      const response = await fetch(url, options("GET"));
      const data = await response.json();
      return data;
    },
  },
  localidades: {
    getAll: async (franquiciaID, redespacho) => {
      const url = `http://192.168.88.12:5600/api/franquicias/${franquiciaID}/localidades?redespacho=${redespacho}`
      const response = await fetch(url, options("GET"));
      const data = await response.json();
      return data;
    }
  },
  nominatim: {
    search: async (q = "") => {
      const url = `https://nominatim.openstreetmap.org/search?q=${q}&format=json&addressdetails=1&polygon_geojson=1&countrycodes=AR`
      const response = await fetch(url, options("GET"));
      const data = await response.json();
      return data
    }
  }
}

export default filialesEditarApi;

export const getFilial = async (id) => {
  const url = `${config.URL_API_PRIVATE}/filiales/${id}`
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

export const getSecciones = async (q = '') => {
  const url = `${config.URL_API_PRIVATE}/secciones?` + q
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

//Contactos
export const crearContacto = async (filialID, body) => {
  const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/contactos`
  const response = await fetch(url, options("POST", body));
  const data = await response.json();
  return data;
};
export const getContactos = async (filialID) => {
  const url = `${config.URL_API_PRIVATE}/filiales/${filialID}/contactos`
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};
export const getContacto = async contactoID => {
  const url = `${config.URL_API_PRIVATE}/filiales/contactos/${contactoID}`
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};
export const editarContacto = async body => {
  const url = `${config.URL_API_PRIVATE}/filiales/contactos`
  const response = await fetch(url, options("PUT", body));
  const data = await response.json();
  return data;
};
export const editarContactoProp = async body => {
  const url = `${config.URL_API_PRIVATE}/filiales/contactosprops`
  const response = await fetch(url, options("PUT", body));
  const data = await response.json();
  return data
};
export const crearContactoProp = async body => {
  const url = `${config.URL_API_PRIVATE}/filiales/contactosprops`
  const response = await fetch(url, options("POST", body));
  const data = await response.json();
  return data;
};
export const getTiposContactos = async () => {
  const url = `${config.URL_API_PRIVATE}/agendas/tiposcontactos`
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};
export const getRoles = async () => {
  const url = `${config.URL_API_PRIVATE}/agendas/roles`
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

//Contratistas
export const getContratistasByFilial = async (filialID, query = "") => {
  const res = await fetch(`${config.URL_API_PRIVATE}/filiales/${filialID}/contratistas?${query}`, options("GET"))
  const data = await res.json()
  return data
};

export const updateContratista = async (body) => {
  const res = await fetch(`${config.URL_API_PRIVATE}/contratistas`, options("PUT", body))
  const data = await res.json()
  return data
};

export const createContratista = async (body) => {
  const res = await fetch(`${config.URL_API_PRIVATE}/contratistas`, options("POST", body))
  const data = await res.json()
  return data
};

//Domicilios
export const verificarDominio = async (dominio = "", q = "") => {
  const res = await fetch(`${config.URL_API_PRIVATE}/vehiculos/${dominio}?${q}`, options("GET"))
  const data = await res.json()
  return data
};